import ChatDialog from './ChatDialog';

export default ChatDialog;
